import { combineReducers } from 'redux';
import { kycReducerFactory } from 'state/secondaryMarket/shared/kyc/kyc.reducer';

import { clientReducer } from './client/client.reducer';
import { productReducer } from './product/product.reducer';
import type { CpOrderReferential } from './referential.model.';

export const cpOrderReferentialReducer = combineReducers<CpOrderReferential>({
  product: productReducer,
  client: clientReducer,
  kyc: kycReducerFactory('CP_ORDER', 'closePriceOrder'),
});
